import { getRatioListAction } from './apis/capaCityPatio';
import { idToHumanLowerCase } from '~/misc/equipment';
import stateMap from './compontents/RegionSelect/stateMap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import { loadsSearchDriectly } from '~/modules/loadsSearch/actions';
import RatioHeader from './compontents/RatioHeader';
import RatioList from './compontents/RatioList';
import { getLoads } from '~/modules/cityRatioList/actions';
import { ModeType, SortName } from './modelData';
import css from './style.css';
import RatioMap from './compontents/RatioMap';
import { getUrlQeury } from '~/misc/formatUrlquery';
import { push as changeURL } from 'react-router-redux';
import * as urls from '~/routing/urls';
import { modalChange } from '~/modules/modal/actions';
import { removeQuery } from '~/misc/getQuery';
import deeplink from '~/misc/deeplink';
const openDeeplink = () => {
  const [isMobile] = removeQuery(['isMobile']);
  if(isMobile) {
    setTimeout(()=> {
      window.location.href = deeplink.openCapacityRatio({hash: isMobile});
    }, 0)
  }
} 
const MapListToMap = list =>
  list.reduce((acc, cur) => {
    acc[cur.state] = {
      in: cur.in,
      out: cur.out,
      count: cur.in + cur.out,
    };
    return acc;
  }, {});

const SortKey = {
  state: 'state',
  inbound: 'in',
  intrastate: 'intrastate',
  outbound: 'out',
};
class index extends Component {
  constructor(props) {
    super(props);

    const query = getUrlQeury();
    const to = query.to || ModeType.LIST;
    const region = query.region || 'usa'
    removeQuery['to', 'region']
    this.state = {
      equipmentValue: [],
      regionValue: region,
      modelType: to,
      listData: [],
      sortName: SortName.State,
      sortBool: true,
      timeStamp: Date.now(),
      tableLoading: false,
      currentItem: '',
      loadsSortBy: 'age',
      loadsSortOrder: 'desc',
    };
    this.equipmentChangeHandel = this.equipmentChangeHandel.bind(this);
    this.regionChangeHandel = this.regionChangeHandel.bind(this);
    this.modelTypeChangeHandler = this.modelTypeChangeHandler.bind(this);
    this.sortClickHandler = this.sortClickHandler.bind(this);
    this.itemClickhandel = this.itemClickhandel.bind(this);
    this.sortItem = this.sortItem.bind(this);
    this.getListData = this.getListData.bind(this);
  }

  equipmentChangeHandel(value) {
    this.setState({
      equipmentValue: value,
    });
  }

  regionChangeHandel(value) {
    this.setState({
      regionValue: value,
    });
  }

  modelTypeChangeHandler(type) {
    return () => {
      this.setState({
        modelType: type,
      });
    };
  }

  sortClickHandler(sortName) {
    return () => {
      if (sortName !== this.state.sortName) {
        this.setState(
          {
            sortName,
            sortBool: true,
          },
          () => {
            this.sortItem();
          }
        );
      } else {
        this.setState(
          {
            sortBool: !this.state.sortBool,
          },
          () => {
            this.sortItem();
          }
        );
      }
    };
  }

  sortItem() {
    const { sortName, sortBool, listData } = this.state;
    let data = [...listData];

    if (sortName === SortName.State) {
      data.sort((a, b) => {
        if (a.state > b.state) {
          return sortBool ? 1 : -1;
        } else return sortBool ? -1 : 1;
      });
    } else {
      const key = SortKey[sortName];
      data.sort((a, b) => {
        return sortBool ? a[key] - b[key] : b[key] - a[key];
      });
    }
    this.setState({
      listData: data,
    });
  }

  itemClickhandel(state) {
    return () => {
      this.searchLoads(state);
      this.setState({
        currentItem: state,
      });
    };
  }
  loadsSort = ({ sort_by, sort_order }) => {
    this.setState({
      loadsSortBy: sort_by,
      loadsSortOrder: sort_order.toUpperCase(),
    });
  };

  searchLoads(state) {
    const { search } = this.props;
    const { equipmentValue, loadsSortBy, loadsSortOrder } = this.state;
    this.setState({
      tableLoading: true,
    });
    search({
      equipment: idToHumanLowerCase[equipmentValue[0]],
      pickUp: state,
      offset: 0,
      limit: 200,
      sort: loadsSortBy,
      sortOrder: loadsSortOrder,
    }).then(() => {
      this.setState({
        tableLoading: false,
      });
    });
  }

  getListData() {
    const equipments = this.state.equipmentValue.map(item => idToHumanLowerCase[item]);
    const state = stateMap[this.state.regionValue];

    const params =
      equipments.length > 0
        ? {
            equipments,
            state,
          }
        : { state };

    this.props.getRatioList(params).then(res => {
      let { code, data = [] } = res;
      if (code === 200) {
        if (!data.length) {
          data = params.state
            .map(item => {
              return { state: item, in: 0, intrastate: 0, out: 0 };
            })
            .sort((a, b) => {
              if (a.state > b.state) {
                return 1;
              } else return -1;
            });
        }
        this.setState({
          listData: data.sort((a, b) => {
            if (a.state > b.state) {
              return 1;
            } else return -1;
          }),
        });
        const [{ state }] = data;
        this.setState({
          currentItem: state,
        }, () => {
          this.setState({
            timeStamp: Date.now(),
          });
        });
        this.searchLoads(state);
      }
    });
  }

  componentDidUpdate(nexProps, nextState) {
    if (
      (nexProps.equipmentBool === true && !this.props.equipmentBool) ||
      nextState.regionValue !== this.state.regionValue
    ) {
      this.getListData();
    }
  }

  componentDidMount() {
    console.log("MOUNT");
    openDeeplink()
    this.getListData();
  }
  render() {
    const {
      equipmentValue,
      regionValue,
      modelType,
      listData,
      sortName,
      sortBool,
      timeStamp,
      tableLoading,
      currentItem,
    } = this.state;

    const mapData = MapListToMap(listData);
    const { isMember } = this.props;
    return (
      <div className={css.CapacityRatio}>
        <div className={css.RatioTitle}>Capacity Ratio</div>
        <RatioHeader
          equipmentHandel={this.equipmentChangeHandel}
          regionHandel={this.regionChangeHandel}
          modelTypeChangeHandler={this.modelTypeChangeHandler}
          equipmentValue={equipmentValue}
          regionValue={regionValue}
          modelType={modelType}
        />
        {modelType === ModeType.LIST ? (
          <RatioList
            listData={listData}
            isMember={isMember}
            sortClickHandler={this.sortClickHandler}
            itemClickhandel={this.itemClickhandel}
            sortName={sortName}
            sortBool={sortBool}
            tableLoading={tableLoading}
            currentItem={currentItem}
            loadsSort={this.loadsSort}
          />
        ) : (
          <RatioMap
            timeStamp={timeStamp}
            isMember={isMember}
            mapData={mapData}
            region={regionValue}
            jumpTo={location =>
              this.props.gotoList({
                location,
                equipment: equipmentValue.length ? equipmentValue.join(',') : null,
              })
            }
            popUp={this.props.showUpgradeToMember}></RatioMap>
        )}
      </div>
    );
  }
}

export default connect(
  (state, props) => ({
    equipmentBool: state.dropdowns.equipment,
    isMember: parseInt(state.account.accountLevel) === parseInt(state.account.professional),
  }),
  mapDispatch({
    search: (props, query) => getLoads(query),
    getRatioList: (_, params) => getRatioListAction(params),
    gotoList: (props, { location, equipment }) =>
      window.open(
        `${urls.CAPACITYRATIOMAPLIST}?location=${location}${
          equipment ? '&equipment=' + equipment : ''
        }`,
        '_self'
      ),
    showUpgradeToMember: (props, source) =>
      modalChange('pop', {
        source: source,
        type: 'pop_upgrade_to_new_professional',
      }),
  })
)(index);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/index.js